import React, { useEffect, useState } from 'react'
import { Space } from 'antd'
import { useGwGoodsGuigeListQuery } from '../store/ReactWebSiteApi'

function SoftSpec(props) {
    const { data, isSuccess } = useGwGoodsGuigeListQuery({ eowgg_eowg_id: props.eowgg_eowg_id }, { refetchOnMountOrArgChange: 1 })
    const [list, setList] = useState([])
    useEffect(() => {
        if (isSuccess) {
            if (data.Status === 'success') {
                const newArr = data.Result.map((item) => {
                    const {
                        eowgg_id: key,
                        eowgg_eowg_id,
                        eowgg_name,
                        eowgg_uname,
                        eowgg_ctime,
                        eowgg_update_ctime,
                        eowgg_update_uname,
                        eowgg_jiage,
                        eowgg_image,
                    } = item
                    return {
                        ...item,
                        key,
                        eowgg_eowg_id,
                        eowgg_name,
                        eowgg_uname,
                        eowgg_ctime,
                        eowgg_update_ctime,
                        eowgg_update_uname,
                        eowgg_jiage,
                        eowgg_image,
                    }
                })
                const sortArr = newArr.sort((a, b) => a.eowgg_serial_number - b.eowgg_serial_number)
                setList(sortArr)
            } else {
                setList([])
            }
        }
    }, [data, isSuccess])

    return (
        <>
            {list.map((item) => (
                <div
                    key={item.key}
                    style={{
                        border: '2px solid #eee',
                        borderRadius: 6,
                        padding: '10px',
                        marginBottom: 10,
                        fontSize: 15,
                    }}
                >
                    <Space wrap>
                        {item.eowgg_name}
                        {item.eowgg_jiage}
                    </Space>
                </div>
            ))}
        </>
    )
}

export default SoftSpec
